import { RendererInterface } from '@jump-tech-frontend/domain';

export class NoopRender implements RendererInterface {
  public render(template: string, _context: unknown): string {
    return template;
  }
}
